import { http } from 'connex-cds';

export default {
  createRole: ({ entityRef, role }) => http.post({ apiName: 'authnz', path: `/${entityRef}/roles`, data: role }),
  listRoles: ({ entityRef }) => http.get({ apiName: 'company-admin', path: `/${entityRef}/roles` }),
  updateRole: ({ entityRef, role }) =>
    http.patch({ apiName: 'authnz', path: `/${entityRef}/roles/${role.crn}`, data: role }),
  deleteRole: ({ entityRef, roleRef }) => http.delete({ apiName: 'authnz', path: `` }),
};
